import { createAction } from 'helpers/redux';
import ACTIONS from 'constants/actionTypes';

export const wl = (payload) => {
  return (dispatch) => {
    dispatch(
      createAction({
        type: ACTIONS.SET_WL,
        payload,
      })
    );
  };
};

export const updateBrandConfig = (payload: {
  id: string;
  config: {
    theme: { [key: string]: string };
    assets: { [key: string]: string };
  };
}) => {
  return (dispatch) => {
    dispatch(
      createAction({
        type: ACTIONS.UPDATE_BRAND_CONFIG,
        payload,
      })
    );
  };
};
